import { VSlider } from 'vuetify/lib/components/VSlider';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSlider,_vm._b({attrs:{"thumb-label":_vm.thumbLabel},model:{value:(_vm.lazyValue),callback:function ($$v) {_vm.lazyValue=$$v},expression:"lazyValue"}},'v-slider',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }